import { render } from "./supplier_performance.vue?vue&type=template&id=588920d5"
import script from "./supplier_performance.vue?vue&type=script&lang=js"
export * from "./supplier_performance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__